module.exports = __webpack_public_path__ + "static/img/cerebrum.3871de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cerebrum.png
// module id = +0Rl
// module chunks = 1